import React from 'react';
import { MessageBox, MessageBoxProps } from 'components/_new/MessageBox';

type PinkQuestionsProps = Omit<MessageBoxProps, 'title' | 'variant'>;

export const PinkQuestions = (props: PinkQuestionsProps) => {
	return <MessageBox variant="pink-questions" {...props} />;
};
